import { CompanyAPI } from '@api';

const getDriverById = (driverId) => CompanyAPI.getDriverById({ driverId })
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response));

export { getDriverById };
